// Import model
import { FilterContactRequest } from '../models/FilterContactRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactCondition } from '../models/ContactCondition';
import { ContactFields } from '../models/ContactFields';
import { ContactIndexedFields } from '../models/ContactIndexedFields';

// Import dependency serializers (for complex types)
import { ContactConditionSerializer } from './ContactConditionSerializer';
import { ContactFieldsSerializer } from './ContactFieldsSerializer';
import { ContactIndexedFieldsSerializer } from './ContactIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContactRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContactRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContactRequest instance
   */
  static deserialize(json: string): FilterContactRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContactRequest instance
   */
  static fromObject(obj: any): FilterContactRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContactRequest');
    }


    const instance: FilterContactRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContactIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContactFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContactConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContactRequest instances
   */
  static deserializeArray(json: string): FilterContactRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContactRequest instance to a JSON string
   */
  static serialize(instance: FilterContactRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContactRequest instance to a plain object
   */
  static toObject(instance: FilterContactRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContactConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContactRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContactRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
